var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagenCalculadoraM2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "340px",
    height: "249px",
    viewBox: "0 0 340 249",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1280,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculadoraV3-comocalcular",
    transform: "translate(-586.000000, -350.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30-Copy",
    transform: "translate(324.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(262.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cuadrado-copy",
    transform: "translate(40.812237, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-15",
    fill: "#C6C3C3",
    points: "166.088167 4.35168558 291.618748 46.5678161 291.702951 177.49666 142.747141 243.288324 6.72534726 187.569237 6.65177452 57.2562479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.193421,7.40037804 L166.08106,121.501931 L11.2042762,177.701782 L10.923699,58.4245194 L167.193421,7.40037804 Z",
    id: "Rectangle",
    stroke: "#C6C3C3",
    fill: "#F4F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.478092,7.40074423 L288.437515,121.872832 L166.564798,166.446325 L165.531953,48.0116856 L288.478092,7.40074423 Z",
    id: "Rectangle-Copy",
    stroke: "#C6C3C3",
    fill: "#F4F2F2",
    transform: "translate(227.003564, 86.934127) scale(-1, 1) translate(-227.003564, -86.934127) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-2",
    fill: "#F4F2F2",
    transform: "translate(149.050886, 175.516714) scale(-1, 1) translate(-149.050886, -175.516714) ",
    points: "11.9650604 166.837761 133.072982 122.109929 286.136712 177.940835 155.331062 228.923499"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(179.512658, 35.261415)",
    stroke: "#C6C3C3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    points: "0 0 64.1116635 22.1568863 64.1116635 63.0431357 0 39.8302289"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-16",
    points: "9.63205387 3.44981016 9.61674952 36.8480068 63.8166549 55.2789599"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 39.5355258,
    x2: 9.82648838,
    y2: 36.6140082,
    id: "Path-17"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-18",
    stroke: "#C6C3C3",
    points: "70.5460938 155.867213 70.85832 57.6863316 113.213056 43.2224024 113.213056 140.148865"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(0.000000, 56.457192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(0.000000, 55.531664)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#0072CE",
    cx: 13.882916,
    cy: 13.9015973,
    rx: 13.882916,
    ry: 13.9015973
  }), /*#__PURE__*/React.createElement("text", {
    id: "A",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 17,
    fontWeight: "bold",
    "line-spacing": 22,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8.32974958,
    y: 18.0318605
  }, "A"))), /*#__PURE__*/React.createElement("path", {
    id: "Line-2-Copy-2",
    d: "M32.8562345,-0.5 L37.3562345,8.5 L33.356,8.5 L33.3562345,139.32916 L32.3562345,139.32916 L32.356,8.5 L28.3562345,8.5 L32.8562345,-0.5 Z",
    fill: "#0072CE",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(57.562131, 88.850662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line-2",
    d: "M266.110643,64.4929723 C266.204781,64.7196627 266.119726,64.9760355 265.920549,65.1045893 L265.840635,65.1464979 L135.987,119.071 L137.521283,122.765139 L127.483652,122.060898 L134.069624,114.453338 L135.603,118.147 L265.457118,64.2229644 C265.712144,64.1170589 266.004738,64.2379456 266.110643,64.4929723 Z",
    fill: "#508221",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-2",
    d: "M134.806662,15.973635 L144.812684,17.036422 L137.958841,24.4035677 L136.557,20.656 L0.175121075,71.6541224 C-0.0835302181,71.7508391 -0.371612895,71.6195652 -0.468329595,71.3609139 C-0.554299994,71.1310017 -0.460129652,70.877835 -0.256482477,70.7564869 L-0.175121075,70.7174633 L136.207,19.72 L134.806662,15.973635 Z",
    fill: "#508221",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-2-Copy",
    d: "M152.244017,16.0256598 L152.331243,16.0487713 L257.625,54.293 L258.990846,50.5338239 L265.913839,57.8360267 L255.918281,58.9930995 L257.283,55.233 L151.989847,16.9886908 C151.730295,16.8944169 151.596311,16.6075846 151.690585,16.348033 C151.774384,16.1173205 152.010328,15.9858218 152.244017,16.0256598 Z",
    fill: "#508221",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-2-Copy-3",
    d: "M11.5124494,74.5817764 L10.039,78.3 L123.763329,123.340113 C124.020069,123.441793 124.145771,123.73235 124.044091,123.989091 C123.953709,124.217305 123.71409,124.341982 123.48164,124.295457 L123.395113,124.269853 L9.671,79.23 L8.1985041,82.9494384 L1.48781482,75.4516621 L11.5124494,74.5817764 Z",
    fill: "#508221",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(184.926135, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#508221",
    cx: 13.882916,
    cy: 13.882916,
    r: 13.882916
  }), /*#__PURE__*/React.createElement("text", {
    id: "B",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 17,
    fontWeight: "bold",
    "line-spacing": 22,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9.09194889,
    y: 19.4201521
  }, "B"))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagenCalculadoraM2);
export default __webpack_public_path__ + "static/media/imagen-calculadora-m2.559606bc.svg";
export { ForwardRef as ReactComponent };